import { __rest } from "tslib";
import React from 'react';
import classnames from 'classnames';
import cloneDeep from 'lodash/cloneDeep';
import { connectField, filterDOMProps } from 'uniforms';
const ListAdd = (_a) => {
    var { addIcon, className, disabled, parent, value } = _a, props = __rest(_a, ["addIcon", "className", "disabled", "parent", "value"]);
    const limitNotReached = !disabled && !(parent.maxCount <= parent.value.length);
    return (React.createElement("div", Object.assign({ className: classnames('badge badge-pill float-right', className), onClick: () => limitNotReached &&
            parent.onChange(parent.value.concat([cloneDeep(value)])) }, filterDOMProps(props)), addIcon));
};
ListAdd.defaultProps = { addIcon: React.createElement("i", { className: "octicon octicon-plus" }) };
export default connectField(ListAdd, {
    includeParent: true,
    initialValue: false,
});
